<template>
  <div>
    <PageHead title="我的预约"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <!-- <div class="query-view">
              <div class="query-view-lable">姓名：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入姓名"
                v-model="queryForm.assetsname"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">手机号：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入手机号"
                v-model="queryForm.assetsname"
              />
            </div> -->
            <div class="query-view mr20">
              <div class="query-view-lable">状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">待办理</a-select-option>
                <a-select-option :value="1">已办理</a-select-option>
                <!-- <a-select-option :value="4">取消</a-select-option> -->
              </a-select>
            </div>
            <!-- </div>
          <blank height="20"> </blank>
          <div class="query-cont"> -->
            <div class="query-view">
              <div class="query-view-lable">日期：</div>
              <a-date-picker
                class="w150"
                valueFormat="YYYY-MM-DD"
                v-model="queryForm.birthTime"
              />
              <a-select
                allowClear
                placeholder="不限"
                class="w100 ml5"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">全天</a-select-option>
                <a-select-option :value="1">上午</a-select-option>
                <a-select-option :value="2">下午</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="goDetial()" icon="plus">
          预约</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="officePhase" slot-scope="text, record">
          <span v-if="record.officePhase == 1"> 全天 </span>
          <span v-if="record.officePhase == 2"> 上午 </span>
          <span v-if="record.officePhase == 3"> 下午 </span>
          {{ record.startTime }}-{{ record.endTime }}
        </span>
        <div slot="state" class="statusDiv" slot-scope="text">
          <!-- <div v-if="text == 0" class="dot1 mr5"></div>
          <div v-if="text == 1" class="dot2 mr5"></div> -->
          <span v-if="text == 0"> 待办理 </span>
          <span v-if="text == 1"> 已办理 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record)">
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '预约单号',
    dataIndex: 'orderNo',
    key: 'orderNo',
    align: 'left',
    width: 140
  },
  {
    title: '预约人部门',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '姓名',
    dataIndex: 'peopleName',
    key: 'peopleName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '预约日期',
    dataIndex: 'makeDate',
    key: 'makeDate',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '办公阶段',
    dataIndex: 'officePhase',
    scopedSlots: { customRender: 'officePhase' },
    key: 'officePhase',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '手机号码',
    dataIndex: 'mobilePhone',
    key: 'mobilePhone',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '身份证号码',
    dataIndex: 'idcard',
    key: 'idcard',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true,
    align: 'left'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 100,
    align: 'left'
  }
]
import { reservationSheetList } from './api/api'
export default {
  data() {
    return {
      expand: false,
      queryForm: {},
      data: [],
      columns,
      page: 1,
      total: 0,
      size: 10,
      loading: false
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      this.page = 1
      this.load()
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      params.userId = this.$store.state.app.userInfo.id
      reservationSheetList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },

    goDetial(record) {
      if (record) {
        this.$router.push('/BookingManagementDetail?id=' + record.id)
      } else {
        this.$router.push('/BookingManagementDetail?type=0')
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 55px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/BookingManagement/MyReservation.vue